module.exports = __webpack_public_path__ + "img/parks-3-4.f22f8fae.jpg";